import 'globals';

(function ($) {
	var init = function () {
			initScrollableHeader();
			initAccordionIcons();
		},
		initScrollableHeader = function() {
			$(window).on('load resize scroll', function () {
				if ($(window).width() >= 768) {
					if ($(window).scrollTop() >= 40) {
						$('.main-header').addClass('fixed-top');
                        $('.breadcrumb-container').addClass('fixed');
					} else {
						$('.main-header').removeClass('fixed-top');
                        $('.breadcrumb-container').removeClass('fixed');
					}
				}
			});
		},
		initAccordionIcons = function () {
			$('.collapse').on('show.bs.collapse', function () {
				$(this).prev().find('.ai-plus4').removeClass('ai-plus4').addClass('ai-minus4');
				$(this).prev().addClass('active');
			}).on('hide.bs.collapse', function () {
				$(this).prev().find('.ai-minus4').removeClass('ai-minus4').addClass('ai-plus4');
				$(this).prev().removeClass('active');
			});
		};
	init();
})(jQuery);
